export default __webpack_public_path__ + "static/illustration-3-0182fe60983f0f4cf37ec55732ac43c9.svg";